import { FilterOptionsState } from '@mui/material';
import { DEFAULT_AUTOCOMPLETE_RESULT_LIMIT } from 'Config';

export const ignoreHyphenFilterOptions = (
  options: string[],
  state: FilterOptionsState<string>,
  resultLimit?: number
) => {
  const filtered = options.filter((option: string) => {
    return `${option}`
      .replaceAll('-', '')
      .includes(state.inputValue.replaceAll('-', ''));
  });
  return filtered?.slice(0, resultLimit || DEFAULT_AUTOCOMPLETE_RESULT_LIMIT);
};
